import { render } from "./MuscleGroupsChart.vue?vue&type=template&id=ea8a95f8&scoped=true"
import script from "./MuscleGroupsChart.vue?vue&type=script&lang=js"
export * from "./MuscleGroupsChart.vue?vue&type=script&lang=js"

import "./MuscleGroupsChart.vue?vue&type=style&index=0&id=ea8a95f8&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea8a95f8"]])

export default __exports__